export const modifyStr = str => {
  let length = str && str.length;
  let modifiedStr = '';
  for (var i = 0; i < length; i++) {
    let prevChar = i === 0 ? '' : str.charAt(i - 1);
    let currChar = str.charAt(i);
    if (prevChar !== '-') {
      modifiedStr += currChar;
    } else if (currChar !== '-') {
      modifiedStr += currChar;
    }
  }

  let modifiedStrLength = modifiedStr.length;
  //remove trailing hypen
  if (modifiedStr.charAt(modifiedStrLength - 1) === '-') {
    modifiedStr = modifiedStr.substring(0, modifiedStrLength - 1);
  }

  return modifiedStr;
};

const validateNotEmpty = (value) => Boolean((value || "").trim());

const validateField = (value, regex = /./, canBeEmpty = false) => {
    if (validateNotEmpty(value)) {
        return regex.test(value.trim());
    }
    return canBeEmpty;
};

export const validateUrl = (
    value,
    { https = false, localhost = false, canBeEmpty = false } = {},
) => {
  const trimmedValue = (value || "").trim();
  if (!trimmedValue) {
    return canBeEmpty;
  }

  let parsedUrl;
  try {
    parsedUrl = new URL(trimmedValue);
  } catch (error) {
    return false;
  }

  if (https && parsedUrl.protocol !== "https:") {
    return false;
  }

  if (!["http:", "https:"].includes(parsedUrl.protocol)) {
    return false;
  }

  if (localhost && parsedUrl.hostname === "localhost") {
    return true;
  }

  const parts = parsedUrl.hostname.split(".");
  const topLevelDomain = parts[parts.length - 1];
  return parts.length > 1 && /^[a-z]{2,63}$/i.test(topLevelDomain);
};
